module.exports = __webpack_public_path__ + "static/media/cheese_contact.d11af915.svg";